import { render, staticRenderFns } from "./menuitems.vue?vue&type=template&id=343be5d6&scoped=true"
import script from "./menuitems.vue?vue&type=script&lang=js"
export * from "./menuitems.vue?vue&type=script&lang=js"
import style0 from "./menuitems.vue?vue&type=style&index=0&id=343be5d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343be5d6",
  null
  
)

export default component.exports